import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNewIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19.361,
	height: 19.361,
	viewBox: "0 0 19.361 19.361",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_6620",
		"data-name": "Path 6620",
		d: "M22.978,16.064H16.064v6.915a1.383,1.383,0,1,1-2.766,0V16.064H6.383a1.383,1.383,0,1,1,0-2.766H13.3V6.383a1.383,1.383,0,1,1,2.766,0V13.3h6.915a1.383,1.383,0,1,1,0,2.766Z",
		transform: "translate(-5 -5)",
		fill: "#f7f8fa"
	})
});
export { SvgNewIcon as ReactComponent };
